<template>
    <d-card-body>
        <d-col class="d-flex">
            <img class="img-fluid network-logo" :src="affiliate.logo">
        </d-col>
        <div class="row">
            <div class="progress-text col-6">
                <h6 class="m-0 mt-5 text-left">
                    <u>1. Connect API</u>
                </h6>
            </div>
            <div class="progress-text col-6">
                <h6 class="m-0 mt-5 text-right">
                    2. Complete
                </h6>
            </div>
        </div>
        <d-progress
            :value="percent"
            :max="100"
        />
        <d-row class="d-flex justify-content-center">
            <d-col lg="6" >
                <d-form
                    id="networkForm"
                    @submit.prevent="createNetwork"
                >
                    <d-form-row
                        v-if="affiliate.config && affiliate.config.credentials_fields"
                        class="mt-5"
                    >
                        <d-col
                            v-if="hasResellers"
                            class="form-group"
                            md="12"
                        >
                            <label for="label">
                                Account name:
                            </label>
                            <d-form-input
                                v-model="accountName"
                                type="text"
                                id="label"
                            />
                        </d-col>
                        <d-col
                            v-if="hasResellers"
                            class="form-group"
                            md="12"
                        >
                            <label for="label">
                                Account color:
                            </label>
                            <b-form-input
                                id="type-color"
                                type="color"
                                v-model="accountColor"
                            >
                            </b-form-input>
                        </d-col>
                        <d-col
                            v-for="(credentialsField, index) in affiliate.config.credentials_fields"
                            :key="index"
                            md="12"
                            class="form-group"
                        >
                            <label :for="credentialsField.name">
                                {{ credentialsField.title }}
                            </label>
                            <div class="help-text">{{ credentialsField.helpText }}</div>
                            <d-form-input
                                v-model="credentials[credentialsField.name]"
                                :type="credentialsField.type"
                                :id="credentialsField.name"
                            />
                        </d-col>
                        <d-col
                            v-if="affiliate.config.multicurrency_per_media"
                            md="12"
                            class="form-group"
                        >
                            <label for="currency">Currency:</label>
                            <d-form-select v-model="currency">
                                <option
                                    v-for="currency in currencies"
                                    :key="currency.code"
                                    :value="currency.code"
                                >
                                    {{ currency.name }}
                                </option>
                            </d-form-select>
                        </d-col>
                        <d-col
                            md="12"
                            class="form-group d-flex justify-content-end"
                        >
                            <input
                                value="Next"
                                type="submit"
                                class="btn btn-success"
                            >
                        </d-col>
                    </d-form-row>
                </d-form>
            </d-col>
        </d-row>
    </d-card-body>
</template>

<script>
    import { AffiliateNetworkService } from '@/main';
    import currency from '@/mixins/currency';
    import notification from '@/mixins/notification';

    export default {
        props: ['affiliate', 'networkName'],

        mixins: [notification, currency],

        data() {
            return {
                login: '',
                password: '',
                currencies: [],
                currency: '',
                accountName: '',
                accountColor: '',
                credentials: {},
                percent: 50
            }
        },

        computed: {
            hasResellers() {
                if (this.affiliate.config && this.affiliate.config.hasOwnProperty('has_resellers')) {
                    return this.affiliate.config.has_resellers
                }
                return false;
            }
        },

        methods: {
            getErrorMessage(e) {
                if (e.extensions.validation) {
                    return e.extensions.validation.network_id[0]
                } else {
                    return e.message
                }
            },

            async createNetwork() {
                try {
                    await AffiliateNetworkService.create(
                        this.credentials,
                        this.$route.params.networkId,
                        this.networkName,
                        this.$route.params.websiteId,
                        this.currency,
                        this.accountName,
                        this.accountColor
                    )
                    this.showNotification('success', 'Alert', 'Network successfully connected!')

                    /*
                    * From domain page the customer clicks on the button Connect new network
                    * The customer gets send to the connect-network route
                    * The customer clicks on the button connect inside network card
                    * The customers fills in his credentials
                    * After successful connection the customers gets send to the connect-network route
                    */
                    if (this.$route.name == 'connect-network') {
                        this.$router.push({ path: `/network/${this.$route.params.websiteId}`})
                    }

                    /*
                    * From add domain page the customer creates a new website
                    * The customers gets send to step 2 add-network
                    * The customer clicks on the button connect inside network card and gets send to the add-network/connect route
                    * The customers fills in his credentials
                    * After successful connection the customers gets send to the add-network route
                    */
                    if (this.$route.name == 'connect') {
                        this.$router.push({ path: `/add-network/${this.$route.params.websiteId}`})
                    }

                    this.$router.go()
                } catch(e) {
                    this.showNotification('error-notification', 'We have a problem!', this.getErrorMessage(e.networkError.result.errors[0]))
                    console.log(e)
                }
            },
        },
    }
</script>

<style scoped>
    #type-color {
        height: 65%;
    }
</style>
